import { render, staticRenderFns } from "./ApiListFieldsCustomization.vue?vue&type=template&id=c14932a2"
import script from "./ApiListFieldsCustomization.vue?vue&type=script&lang=js"
export * from "./ApiListFieldsCustomization.vue?vue&type=script&lang=js"
import style0 from "./ApiListFieldsCustomization.vue?vue&type=style&index=0&id=c14932a2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports